import { NoDataMessage } from '../../NoDataMessage';
import { DashboardData } from '../../../types/commonTypes';
import clsx from 'clsx';

interface Props {
  data: DashboardData[];
  format?: any[];
  orientation?: 'row' | 'column';
  theme: any[];
}

export const Basic = ({ data, format, orientation = 'row', theme }: Props) => {
  const formatData = (value: any, id: any) => {
    if (format != undefined) {
      if (format[0].id == id)
        switch (format[0].value) {
          case 'currency':
            return `$${value}`;
          case 'percent':
            return `${value}%`;
        }
      else return value;
    } else return value;
  };

  return (
    <div
      className={clsx(
        'flex flex-wrap items-center justify-center w-full h-full',
        {
          'flex-row': orientation === 'row',
          'flex-col': orientation === 'column',
        }
      )}
    >
      {data.length > 0 ? (
        data.map((v, index: number) => (
          <div
            key={index}
            className="flex flex-col flex-grow items-center justify-center m-1"
          >
            <span className="text-2xl mx-2">{v.id}</span>
            <span
              className="text-3xl p-2 m-2 border-b-[3px]"
              style={{ borderColor: theme[index] }}
            >
              {formatData(v.value, v.id)}
            </span>
          </div>
        ))
      ) : (
        <NoDataMessage subTitle="Try Again Later" />
      )}
    </div>
  );
};
